import { Component, OnInit } from '@angular/core';
import { LandingModalService } from '@view-offers/services/landing.modal.service';
import { CloseModalType } from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-landing-modal',
  templateUrl: './landing-modal.component.html',
  styleUrls: ['./landing-modal.component.scss'],
  providers: [LandingModalService],
})
export class LandingModalComponent implements OnInit {
  readonly slides$ = this.landingModalService.getSlides$;

  readonly CloseType = CloseModalType;

  constructor(public readonly landingModalService: LandingModalService) {}

  ngOnInit() {
    this.landingModalService.gaLanding();
  }

  onNavigate(slide: number) {
    this.landingModalService.gaSlideNavigation(slide);
  }

  closeModal(type: string) {
    this.landingModalService.setModalViewed(type);
  }
}
